var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMailPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_1109)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_1109",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0H0V14H14V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_1109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4 12.3667C1.015 12.3667 0.685533 12.2297 0.4116 11.9558C0.1372 11.6814 0 11.3517 0 10.9667V2.56666C0 2.18166 0.1372 1.85219 0.4116 1.57826C0.685533 1.30386 1.015 1.16666 1.4 1.16666H12.6C12.985 1.16666 13.3147 1.30386 13.5891 1.57826C13.863 1.85219 14 2.18166 14 2.56666V10.9667C14 11.3517 13.863 11.6814 13.5891 11.9558C13.3147 12.2297 12.985 12.3667 12.6 12.3667H1.4ZM7 7.46666L1.4 3.96666V10.9667H12.6V3.96666L7 7.46666ZM7 6.06666L12.6 2.56666H1.4L7 6.06666ZM1.4 3.96666V2.56666V10.9667V3.96666Z",
    fill: "#00BCE7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_1109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMailPrimary);
export default __webpack_public_path__ + "static/media/ic-mail-primary.bde4a1aa088f51c1103d827dedf3701e.svg";
export { ForwardRef as ReactComponent };